<template>
  <app-layout title="Builder">
    <PageTitle :headerTitle="title"> </PageTitle>

    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
        <form
          class="px-4 pt-4"
          method="post"
          action="{{ route('module.destroy',$module->name) }}"
        >
          <div class="mb-4">
            <!-- <a
              class="
                bg-green-500
                text-white text-xs
                hover:bg-green-700 hover:no-underline
                rounded
                link-btn-style
              "
              href="#"
              id="ediBtn"
              >Edit</a
            >
            <a
              v-on:click="redeploy"
              v-show="isDeployed"
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="reDeployBtn"
              >Redeploy</a
            >
            <a
              v-on:click="deploy"
              v-show="!isDeployed"
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="deployBtn"
              >Deploy</a
            >
            <a
              v-on:click="publish"
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="publishBtn"
              >Publish</a
            >
            <a
              class="
                bg-gray-500
                text-white text-xs
                hover:bg-gray-700 hover:no-underline
                rounded
                ml-2
                link-btn-style
              "
              href="#"
              id="exportBtn"
              >Export</a
            > -->
           

            <jet-button
              @click="deleteModule"
              class="
                bg-red-500
                text-white text-xs
                hover:bg-red-700 hover:no-underline
                rounded
                ml-2
                cursor-pointer
                link-btn-style
              "
              >Delete</jet-button>

     
            
          </div>
        </form>

        <div class="px-4 pb-2">
          <BsShow
            :createDef="createDef"
            :routeDef="route"
            :modelData="moduleData">
          </BsShow>
        </div>

      

         <div class="pt-2">
          <DxTabPanel>
              <DxItem
              v-for="(data,key) in relationData"
              icon="fields"
              :title="data['label']"
              :key="data['route']"
            >
              <div class="px-2" >
                {{ data['route'] }}
                <DetailPanel :routeDef="data['route']" :relationDef="data" :parentId="this.moduleData.id" :parentRoute="this.moduleRoute" >

                </DetailPanel>
              </div>


            </DxItem>
 



          </DxTabPanel>
        </div>

        
    </div>
      <DxToast
        v-model:visible="isVisible"
        v-model:message="message"
        v-model:type="type"
      />
    </div>
  </app-layout>
</template>

<style scoped>
.link-btn-style {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 4px;
  padding-bottom: 4px;
}
.dx-toast-content {
  min-width: 300px;
  max-width: 400px;
}
</style>


<script>
import AppLayout from "@/Layouts/AppLayout.vue";
import BsShow from "@/Base/BsShow.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import JetNavLink from "@/Jetstream/NavLink.vue";
import { DxToast } from "devextreme-vue/toast";
import { confirm, alert } from "devextreme/ui/dialog";
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
/* from Include */
import DetailPanel from '@include/pages/DetailViewPanel.vue';


let collapsed = false;

export default {
  props: {
    isDeployed: Boolean,
    createDef: Array,
    modules: Array,
    moduleRoute: String,
    moduleData: {
      type: Object,
      default: () => ({}),
    },
     relationData :{
                type: Array,
                default: []
            },
  },
  components: {
    AppLayout,
    DxTabPanel,
    DxItem,
    DetailPanel,
    BsShow,
    PageTitle,
    JetNavLink,
    DxToast,
  },

  data() {
    return {
      txt: "kk",
      title: "Product Detail",
      form: this.$inertia.form(),
      isVisible: false,
      message: "",
      type: "success",
    };
  },
  methods: {
    deploy() {
      // this.$inertia.get("/module/deploy/"+this.moduleData.name);

       console.log("Deploy not implemented yet");
    
    },
    redeploy() {
      // this.$inertia.get("/module/redeploy/"+this.moduleData.name);

          console.log("Redeploy not implemented yet");
    },
    publish() {
      // this.$inertia.get("/module/publish/"+this.moduleData.name);
          console.log("Publish not implemented yet");

    },
    globalDeploy()
    {

      console.log("Global Deploy not implemented yet");
      
    },
    showToast(message, type) {
      this.isVisible = true;
      this.message = message;
      this.type = type;
    },

    deleteModule() {
      let result = confirm("<i>Are you sure?</i>", "Confirm changes");
      result.then((dialogResult) => {
        if (dialogResult) {
          this.form.delete(route("builders.product.destroy", this.moduleData.id), {
            errorBag: "delete",
            onSuccess: this.showToast("Successfully Deleted", "success"),
          });
        }
      });
    },
  },
  mounted() {
   console.log(this.moduleData);


   // console.log("IsDeployed",this.isDeployed);
  },
};
</script>
